import { useAmbassadorSnapshot, ambassadorScore, rankedAmbassadors } from "@/lib/ambassadors/ambassadorEngine";
import { AmbassadorBadge } from "./AmbassadorBadge";

export function AmbassadorRanking({ limit = 8 }: { limit?: number }) {
  useAmbassadorSnapshot();
  const rows = rankedAmbassadors(limit);
  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <h3 className="text-sm font-black uppercase tracking-wider">🌎 Ambassador Ranking</h3>
      <ul className="mt-2 space-y-1.5">
        {rows.map((a, i) => (
          <li key={a.id} className="flex items-center justify-between gap-2 rounded-lg px-2 py-1 hover:bg-muted/50">
            <div className="flex items-center gap-2 min-w-0">
              <span className="w-5 text-right text-xs font-black text-muted-foreground">{i + 1}</span>
              <AmbassadorBadge a={a} />
            </div>
            <div className="text-right text-[11px]">
              <div className="font-black tabular-nums">{ambassadorScore(a)}</div>
              <div className="text-muted-foreground">↗ {a.referrals} · 🔥 {a.hype}</div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
